import { Box, styled } from '@mui/material';
import Scrollbar from 'src/components/Scrollbar';
import SidebarMenu from './SidebarMenu';

const logo = require('src/images/static/LUMAN_logo.png');

const SidebarWrapper = styled(Box)(({ theme }) => ({
    width: theme.sidebar.width,
    minWidth: theme.sidebar.width,
    height: '100%',
    paddingBottom: 68,
}));

function Sidebar() {
    return (
        <SidebarWrapper>
            <Scrollbar>
                <Box sx={{ textAlign: 'center', mt: 2 }}>
                    <img src={String(logo)} style={{ height: 100, width: 180 }} alt="Logo" />
                </Box>
                <SidebarMenu />
            </Scrollbar>
        </SidebarWrapper>
    );
}

export default Sidebar;